<button
  type="button"
  [attr.disabled]="disabled ? '' : null"
  #button
  class="timepicker-toggle-button"
>
  <ng-container *ngIf="!iconRef"><i class="{{ icon }} fa-sm timepicker-icon"></i></ng-container>
  <ng-template [ngIf]="iconRef">
    <ng-template [cdkPortalOutlet]="iconRef"></ng-template>
  </ng-template>
</button>
